<script setup lang="ts">
import CourseListView from '../../views/CourseListView/CourseListView.vue';
import BPage from 'src/shared/components/base/BPage/BPage.vue';
</script>

<template>
  <BPage>
    <div class="col fit">
      <CourseListView :filter="{ key: 'is_assigned', value: true }" />
    </div>
  </BPage>
</template>
